import { constants } from '../data/constants'
import { getVisible, getToasts, getMotds } from '../selectors'
import { motdsChanged, reshowNewestMotd, setVisibility, removeToasts } from '../actions'

const ToasterMiddleware = store => next => (action) => {
    switch (action.type) {
        case constants.toasts.ADD_MESSAGE:
        case constants.toasts.REMOVE_TOAST:
        case constants.toasts.REMOVE_TOASTS: {
            // todo: Maybe see if the value has actually changed and only dispatch
            // if so.
            const result = next(action)
            const motds = getMotds(store.getState())
            store.dispatch(motdsChanged(motds))
            return result
        }

        // Handle clicks (when user clicks on toast button)
        case constants.queue.BUTTON_CLICKED: {
            const result = next(action)
            const state = store.getState()

            // First we check the current state...
            const visible = getVisible(state)

            // Then we get the toasts that are currently on display
            const toasts = getToasts(state)

            if (visible && toasts.length < 1) {
                // Reshow the newest motd
                store.dispatch(reshowNewestMotd())
            } else if (visible) {
                // Get the ids of all toasts we are showing
                const ids = toasts.reduce((res, toast) => {
                    res.push(toast.id)
                    return res
                }, [])
                // Dismiss all open toasts
                store.dispatch(removeToasts(ids))
                // Change visibility to false
                store.dispatch(setVisibility(false))
            } else if (toasts.length > 0) {
                // Change visibility to true
                store.dispatch(setVisibility(true))
            } else {
                // Reshow the newest motd
                store.dispatch(reshowNewestMotd())
                // Change visibility to true
                store.dispatch(setVisibility(true))
            }

            return result
        }

        default:
            return next(action)
    }
}

export default ToasterMiddleware



// WEBPACK FOOTER //
// ./src/features/Toaster/middleware/index.js